export enum sortList {
    Country = 0,
    Name = 1,
    CertificateNumber = 2
}
